<template>
  
</template>

<script>
export default {

    created(){
        window.location = '/404'
    },

    beforeRouteEnter(to,from,next){
        axios.post(`/api/redirect`, {path:to.path}).catch(err=>{
            if(_.get(err,'response')){
                switch(err.response.status){
                    case 404:
                    next()
                    if(from.name != null){
                        history.pushState({},null,from.fullPath); 
                    }
                    break
                    case 302:
                    next({path:err.response.data.message})
                    break;
                    default: console.log(err)
                }
            }
        })  
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/js/components/errorPages/CatchAll.vue